import css from "../../css/listing/property-archive.module.css";
import cssBasic from "../../css/listing/property-archive-basic-info.module.css";

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ToastNotification from "../ToastNotification";
import moneyFormatter from "../../helper/moneyFormatter";
import PropertyBasicInfo from "./PropertyBasicInfo";
import PropertyButtons from "./PropertyButtons";
import { getListingValuation } from "../../service/property-valuation";

import ValuationIcon from "../../static/icons/valuation.svg";

const PropertyArchive = (props) => {
    const { listing } = props;

    const [valuation, setValuation] = useState(null);

    useEffect(() => {
        fetchValuation(listing);
    }, [listing]);

    const fetchValuation = async (listing) => {
        setValuation(await getListingValuation(listing.id));
    };

    const showValuation = !!valuation;

    return (
        <div className={css.properties}>
            <ToastNotification />
            <div className={css.firstLine}>
                <PropertyBasicInfo listing={listing} css={cssBasic} />
                {showValuation && (
                    <div className={css.valuation}>
                        <div className={css.rangeContainer}>
                            <div className={css.label}>
                                Estimated Value Range
                            </div>
                            <div className={css.rangeValue}>
                                {moneyFormatter(0).format(valuation.low)} -{" "}
                                {moneyFormatter(0).format(valuation.high)}
                            </div>
                        </div>
                        <div className={css.valueContainer}>
                            <div className={css.valueIcon}>
                                <ValuationIcon />
                            </div>
                            <div className={css.valueValue}>
                                <div className={css.label}>Estimated Value</div>
                                <div className={css.value}>
                                    {moneyFormatter(0).format(valuation.value)}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={css.secondLine}>
                <PropertyButtons listing={listing} />
                <div className={css.offMarket}>Off Market</div>
            </div>
        </div>
    );
};

PropertyArchive.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default PropertyArchive;
